import * as React from 'react';

import { Link } from 'react-router-dom';

import { SubItemsType } from 'ui/NewSideBar/types';

import ItemsDropdown from '../ItemsDropdown';
import { SubItem, SubItemTitle } from './styles';

type SubItemsProps = {
  subItems: SubItemsType | undefined;
};

const SubItems: React.FC<SubItemsProps> = ({ subItems }): JSX.Element[] | null => {
  if (!subItems) {
    return null;
  }

  return subItems.map(({ Icon, name, isSelected, to, ActiveIcon, subItems: nestedItems, emptyText, testId }) => {
    if (nestedItems) {
      return (
        <ItemsDropdown
          Icon={Icon}
          ActiveIcon={ActiveIcon}
          name={name}
          subItems={nestedItems}
          emptyText={emptyText}
          key={name}
        />
      );
    }

    return (
      <Link
        to={to}
        style={{ textDecoration: 'none' }}
        id={`sub-item-link-${name}`}
        key={`${name}_${isSelected}`}
        data-testid={testId}
      >
        <SubItem $selected={isSelected}>
          {isSelected ? ActiveIcon : Icon}
          <SubItemTitle $isSelected={isSelected} id={`sub-item-name-${name}`}>
            {name}
          </SubItemTitle>
        </SubItem>
      </Link>
    );
  });
};

export default SubItems;
